import { useMemo } from "react";
import { format, parseISO } from "date-fns";
import React from "react";
import { Column } from "@/components/Datatable/types";
import { ProductStoreOrderListItem } from "../api/fetchProductStoreOrders/types";
import { UpdatableOrderStatus } from "../api/updateProductStoreOrderStatus/types";
import OrderStatusProgress from "../components/OrderStatusProgress/OrderStatusProgress";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

interface UseOrderColumnsOptions {
  onAdvanceStatus: (
    order: ProductStoreOrderListItem,
    target: UpdatableOrderStatus,
  ) => void;
}

export function useOrderColumns({
  onAdvanceStatus,
}: UseOrderColumnsOptions): Column<ProductStoreOrderListItem>[] {
  return useMemo(
    () => [
      {
        header: "Confirmation #",
        accessorKey: "confirmationNumber",
        enableSorting: true,
        cell: ({ row }) =>
          React.createElement(
            "span",
            { className: "font-mono text-sm" },
            row.original.confirmationNumber,
          ),
      },
      {
        header: "Customer Name",
        accessorKey: "customerName",
        enableSorting: true,
      },
      {
        header: "Company",
        accessorKey: "companyName",
        enableSorting: false,
        cell: ({ row }) =>
          React.createElement(
            "span",
            { className: "whitespace-nowrap" },
            row.original.companyName,
          ),
      },
      {
        header: "Email",
        accessorKey: "contactEmail",
        enableSorting: false,
      },
      {
        id: "amount",
        header: "Total",
        accessorKey: "amount",
        enableSorting: true,
        cell: ({ row }) =>
          React.createElement(
            "span",
            { className: "text-gray-900 dark:text-white" },
            currencyFormatter.format(Number(row.original.amount)),
          ),
      },
      {
        id: "status",
        header: "Status",
        accessorKey: "status",
        enableSorting: false,
        cell: ({ row }) =>
          React.createElement(OrderStatusProgress, {
            status: row.original.status,
            onAdvance: (target) => onAdvanceStatus(row.original, target),
          }),
      },
      {
        header: "Date",
        accessorKey: "finalizedAt",
        enableSorting: true,
        cell: ({ row }) =>
          row.original.finalizedAt
            ? format(parseISO(row.original.finalizedAt), "MMM d, yyyy")
            : "",
      },
    ],
    [onAdvanceStatus],
  );
}